import React from "react";
import "./Skills.css";
import Skillcard from "../Skillcard/Skillcard";
import cppimg from "../../Assets/c++logo.png";
import cimg from "../../Assets/C_Logo.png";
import plogo from "../../Assets/Pythonlogo.png";
import htmlLogo from "../../Assets/HTML5_logo.png";
import csslogo from "../../Assets/CSS3_logo.png";
import jslogo from "../../Assets/JSlogo.png";
import reactlogo from "../../Assets/reactlogo.png";
import nodejslogo from "../../Assets/Nodejslogo.png";
import exlogo from "../../Assets/expressjslogo.png";
import mdblogo from "../../Assets/mongodblogo.png";
import mysqllogo from "../../Assets/MySQL-Logo.png";
import gitlogo from "../../Assets/Git-logo.png";
import githublogo from "../../Assets/GitHub-logo.png";
import jiralogo from "../../Assets/jiralogo.png";
import bitlogo from "../../Assets/bitbucket-logo.png";

const lang = [cppimg, cimg, plogo];
const web = [htmlLogo, csslogo, jslogo, reactlogo, nodejslogo, exlogo];
const db = [mdblogo, mysqllogo];
const tools = [gitlogo, githublogo, jiralogo, bitlogo];
export default function Skills() {
  return (
    <>
      <div style={{ backgroundColor: "#161B22", padding: "10px" }}>
        <p
          style={{
            color: "#9CB4FF",
            marginTop: "0px",
            marginBottom: "0px",
            textAlign: "right",
            fontSize: "25px",
            fontWeight: "600",
            // marginRight: "50px",
            textAlign: "center",
          }}
        >
          My Skills
        </p>
      </div>

      <div className="skills">
        <h2 className="skillhead" style={{ color: "#FBAE00" }}>
          Languages
        </h2>
        <div className="skilldiv1">
          {lang.map((l) => (
            <Skillcard img={l} />
          ))}
        </div>
        <hr color="#FBAE00" />
        <h2 className="skillhead" style={{ color: "#B73CF6" }}>
          Web Technologies
        </h2>
        <div className="skilldiv2">
          {web.map((l) => (
            <Skillcard img={l} />
          ))}
        </div>
        <hr color="#B73CF6" />
        <h2 className="skillhead" style={{ color: "#2DA9DD" }}>
          Databases
        </h2>
        <div className="skilldiv3">
          {db.map((l) => (
            <Skillcard img={l} />
          ))}
        </div>
        <hr color="#2DA9DD" />
        <h2 className="skillhead" style={{ color: "#8FFEB7" }}>
          Tools
        </h2>
        <div className="skilldiv4">
          {tools.map((l) => (
            <Skillcard img={l} />
          ))}
        </div>
        <hr color="#8FFEB7" />
      </div>
    </>
  );
}
